module.exports = __webpack_public_path__ + "static/banner-image-6-c5a921723d3d0b6a4b990dcd81e47e6d.jpg";